import React from 'react';
import Switch from './../assets/ui_assets/controls/Switch';
import CheckBox from './../assets/ui_assets/controls/CheckBox';
import { LocalizationContext } from 'localization-context';
import { AlexaCommon } from '../utils/Common';
import SynapseWebServiceSettings from 'settings/AlexaWebService.json';
const autoBind = require('auto-bind');

class RZDNDPanel extends React.Component {

    constructor(props) {
        super(props);
        autoBind(this);
    }
    /**
     * @emits window.rzevent.EventTypes.ALEXA_ENABLE_CHECKED
     */
    onAlexaEnabled = ()=>{
        window.rzevent.triggerEvent(window.rzevent.EventTypes.ALEXA_ENABLE_CHECKED, !this.props.alexaStatus);
        AlexaCommon.consoleLogDataUIImportantInfo("ALEXA_ENABLE_CHECKED event is called" , this.props.alexaStatus);
        if (typeof this.props.handleOnAlexaStatusChange === "function"){
            this.props.handleOnAlexaStatusChange(!this.props.alexaStatus);
        }
    }

    /**
     * @method this.props.handleAlexaApplicationSoundDataChange
     * @emits window.rzevent.EventTypes.APP_SOUNDS_CHECKED
     */
    onCheckAppSounds = () =>{
        if (typeof this.props.handleAlexaApplicationSoundDataChange === "function"
         && typeof this.props.alexaApplicationSoundData !== "undefined"){
            this.props.handleAlexaApplicationSoundDataChange(!this.props.alexaApplicationSoundData[SynapseWebServiceSettings.Enable_Key]);
        }
    }

    /**
     * @method this.props.handleAlexaDisplayCardLayoutDataChange
     * @emits window.rzevent.EventTypes.DISPLAY_CARDS_CHECKED
     */
    onCheckDisplayCards = ()=> {
        if (typeof this.props.handleAlexaDisplayCardLayoutDataChange === "function"
            && typeof this.props.alexaDisplayCardLayoutData !== "undefined"){
            this.props.handleAlexaDisplayCardLayoutDataChange(!this.props.alexaDisplayCardLayoutData[SynapseWebServiceSettings.Enable_Key]);
        }
    }

    render() {
        let soundData = this.props.alexaApplicationSoundData ? this.props.alexaApplicationSoundData[SynapseWebServiceSettings.Enable_Key] : false;
        let displayCards = this.props.alexaDisplayCardLayoutData ? this.props.alexaDisplayCardLayoutData[SynapseWebServiceSettings.Enable_Key] : false;
        return (
            <LocalizationContext.Consumer>
                {values => (
                    <div className="settings-container-1">
                        <div className="settings-wrapper-1">
                            <div className="settings-title alexa-inline-block">
                                <span>{values.alexa}</span>
                                <span className="alexa-border-box alexa-inline-block" style={{ marginLeft: '10px' }}>
                                    <Switch active={this.props.alexaStatus} onClick={this.onAlexaEnabled} />
                                </span>
                            </div>
                            <div className="settings-subcontent settings-dnd">
                                <div className="settings-subtitle settings-subcontent">
                                    <CheckBox
                                        id= "checkAppSounds"
                                        disabled={!this.props.alexaStatus}
                                        active={soundData}
                                        onCheck={this.onCheckAppSounds}
                                        name={values.appSound}
                                    />
                                </div>
                                <div className="settings-subtitle">
                                    <CheckBox
                                        id= "checkDisplayCards"
                                        disabled={!this.props.alexaStatus}
                                        active={displayCards}
                                        onCheck={this.onCheckDisplayCards}
                                        name={values.displayCard}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </LocalizationContext.Consumer>
        );
    }
}
export default RZDNDPanel;
